module.exports = __webpack_public_path__ + "img/yuyue.4027bd8b.png";